import { useCallback, useState } from 'react';
import type { Order } from '../../../api/order';

export type OrderUpdatedHandler = (order?: Order) => void | Promise<void>;

interface UseOrderDetailHandlersOptions {
  onRefresh: () => void | Promise<void>;
  onApplyOrder: (order: Order) => void;
}

export function useOrderDetailHandlers({
  onRefresh,
  onApplyOrder,
}: UseOrderDetailHandlersOptions): {
  handleUpdated: OrderUpdatedHandler;
  historyRefreshKey: number;
} {
  const [historyRefreshKey, setHistoryRefreshKey] = useState(0);

  const handleUpdated = useCallback<OrderUpdatedHandler>(
    async (order) => {
      if (order) {
        onApplyOrder(order);
      } else {
        await onRefresh();
      }
      setHistoryRefreshKey((key) => key + 1);
    },
    [onApplyOrder, onRefresh]
  );

  return { handleUpdated, historyRefreshKey };
}
